export default __webpack_public_path__ + "static/media/vertically-split-promotional-content-background.537d3e0c.jpeg";